export default "__VITE_ASSET__DovTYFoq__"